import { render, staticRenderFns } from "./bcpqs.vue?vue&type=template&id=55007207&scoped=true&"
import script from "./bcpqs.vue?vue&type=script&lang=js&"
export * from "./bcpqs.vue?vue&type=script&lang=js&"
import style0 from "./bcpqs.vue?vue&type=style&index=0&id=55007207&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55007207",
  null
  
)

export default component.exports